webpackJsonp([35704964037736],{

/***/ 323:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(16);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _slugify = __webpack_require__(53);
	
	var _slugify2 = _interopRequireDefault(_slugify);
	
	var _config = __webpack_require__(33);
	
	var _breadcrumbs = __webpack_require__(95);
	
	var _breadcrumbs2 = _interopRequireDefault(_breadcrumbs);
	
	var _clockIcon = __webpack_require__(92);
	
	var _clockIcon2 = _interopRequireDefault(_clockIcon);
	
	__webpack_require__(122);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewsPage = function (_React$Component) {
	  _inherits(NewsPage, _React$Component);
	
	  function NewsPage(props) {
	    _classCallCheck(this, NewsPage);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  NewsPage.prototype.renderImage = function renderImage(image) {
	    if (image) {
	      var _image$sizes = image.sizes,
	          src = _image$sizes.src,
	          srcSet = _image$sizes.srcSet,
	          title = _image$sizes.title;
	
	      return _react2.default.createElement('img', { src: src, srcSet: srcSet, className: 'feature-image', alt: title });
	    }
	
	    return null;
	  };
	
	  NewsPage.prototype.renderArticle = function renderArticle(article) {
	    var image = this.renderImage(article.featureImage);
	    var backgroundColor = article.backgroundColor || 'white';
	    var linkClass = image ? '' : 'no-image';
	
	    return _react2.default.createElement(
	      'div',
	      { style: { backgroundColor: backgroundColor }, className: 'article-container', key: article.id },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/' + this.props.lang + '/article/' + (0, _slugify2.default)(article.heading, _config.slugifyOptions), className: 'unstyled article-link ' + linkClass },
	        _react2.default.createElement(
	          'div',
	          { className: 'image-container' },
	          image
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'article-content' },
	          _react2.default.createElement(
	            'div',
	            { className: 'content-wrapper' },
	            _react2.default.createElement(
	              'div',
	              { className: 'date' },
	              _react2.default.createElement(_clockIcon2.default, { className: 'icon' }),
	              ' ',
	              _react2.default.createElement(
	                'time',
	                { className: 'created-at' },
	                article.createdAt
	              )
	            ),
	            _react2.default.createElement(
	              'h5',
	              null,
	              article.heading
	            )
	          )
	        )
	      )
	    );
	  };
	
	  NewsPage.prototype.render = function render() {
	    var _this2 = this;
	
	    var news = this.props.content;
	    var _props = this.props,
	        lang = _props.lang,
	        localization = _props.localization;
	
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_breadcrumbs2.default, { lang: lang, localization: localization }),
	      _react2.default.createElement(
	        'div',
	        { className: 'news-list-container news-page-container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'news-container', 'data-cy': 'faq-page-search' },
	          news.map(function (article) {
	            return _this2.renderArticle(article.node);
	          })
	        )
	      )
	    );
	  };
	
	  return NewsPage;
	}(_react2.default.Component);
	
	exports.default = NewsPage;
	module.exports = exports['default'];

/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _newsPage = __webpack_require__(323);
	
	var _newsPage2 = _interopRequireDefault(_newsPage);
	
	var _localization = __webpack_require__(46);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NewsPageEn = function (_React$Component) {
	  _inherits(NewsPageEn, _React$Component);
	
	  function NewsPageEn() {
	    _classCallCheck(this, NewsPageEn);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  NewsPageEn.prototype.render = function render() {
	    var _props$data = this.props.data,
	        globalLocalization = _props$data.globalLocalization,
	        news = _props$data.news;
	
	    var localization = (0, _localization.getLocalization)(globalLocalization, 'en-US');
	
	    var filteredNews = news.edges.filter(function (edge) {
	      var node = edge.node;
	      return node.heading && node.body && node.body.body;
	    });
	
	    return _react2.default.createElement(_newsPage2.default, { content: filteredNews, localization: localization, lang: 'en' });
	  };
	
	  return NewsPageEn;
	}(_react2.default.Component);
	
	exports.default = NewsPageEn;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-news-en-js-7947ee769cf7fb0c4c28.js